// 经络风险评估模块
// 依赖：tizhi_jingluo 已在 pipeline.parseBase 中完成 JSON.parse
export default function transform(data) {
    if (data && data.tizhi_content) {
        data.jingluo = data.tizhi_content.jingluo || [];
    }
}
